const values = {
  1: "lg:columns-1",
  2: "lg:columns-2",
  3: "lg:columns-3",
};

export default function getColumnsLg(value) {
  return values[value];
}
